import { cn } from "@/lib/utils";

export function Dash({ className }: { className?: string }) {
  return <span className={cn("text-slate-400", className)}>—</span>;
}
